/**
 * New Taiwan dollar.
 */
export var TWD = {
  code: 'TWD',
  base: 10,
  exponent: 2
};